import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';
import { DoFiltersService } from '@app/main/main-content/display-options/services/do-filters/do-filters.service';
import { DoFilterKey } from '@app/main/main-content/display-options/enums/do-filter-key.enum';
import { ILdLoggerFilters } from '@app/main/leak-detection/interfaces/ld-logger-filters';
import { LeakDetectionMode } from '@app/core/enums/leak-detection-mode.enum';
import { selectMainProjectId } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';
import { selectProjectEntities } from '@app/main/main-screen/store/projects/projects.selectors';

@Injectable({ providedIn: 'root' })
export class LdLoggerFiltersService {
  private store = inject(Store);
  private doFiltersService = inject(DoFiltersService);

  public getLoggerFilters(): Observable<ILdLoggerFilters> {
    return combineLatest([
      this.doFiltersService.getFilter(DoFilterKey.LoggerType),
      this.doFiltersService.getFilter(DoFilterKey.LoggersByAIPredictor),
      this.getLeakDetectionMode(),
    ]).pipe(map(([loggerType, loggersByAi, leakDetectionMode]) => ({ loggerType, loggersByAi, leakDetectionMode })));
  }

  private getLeakDetectionMode(): Observable<LeakDetectionMode> {
    return combineLatest([this.store.select(selectMainProjectId), this.store.select(selectProjectEntities)]).pipe(
      map(([projectId, projectsMap]) => projectsMap[projectId!]?.leakDetectionMode ?? LeakDetectionMode.LeakScore),
      distinctUntilChanged()
    );
  }
}
